// Marks an image `loaded` or `failed` once the browser settles it, so CSS can
// swap the skeleton for the image or for the monogram/initials beneath it.
// The state is set through `js()`, which LiveView re-applies after every patch,
// and it is re-read on update because a patch can swap the source.
export const ImageSkeleton = {
  mounted() {
    this.track()
  },

  updated() {
    this.track()
  },

  track() {
    const img = this.el
    const settle = () => {
      if (img.isConnected) {
        this.js().setAttribute(
          img,
          "data-image-state",
          img.naturalWidth > 0 ? "loaded" : "failed",
        )
      }
    }
    if (img.complete) {
      settle()
      return
    }
    this.js().setAttribute(img, "data-image-state", "loading")
    img.addEventListener("load", settle, { once: true })
    img.addEventListener("error", settle, { once: true })
  },
}
